module.exports = __webpack_public_path__ + "img/nol.aedee6c1.png";